"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RepeatingLastDayEditor = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const Date_1 = require("../../../Form/Field/Date");
const RepeatingLastDayEditor = (props) => {
    const { field, disabledBeforeDay } = props;
    const fieldProps = {
        autoComplete: 'off',
        name: 'lastDate',
        showUpper: true,
        restrictions: { disabledBeforeDay },
        label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Edit/Repeating:LastFlight', defaultMessage: 'Last flight' })),
        modificators: field.modifiers,
        error: field.error,
        value: field.value,
        setValue: field.onValue,
    };
    return (react_1.default.createElement(Date_1.FormFieldDate, { ...fieldProps }));
};
exports.RepeatingLastDayEditor = RepeatingLastDayEditor;
//# sourceMappingURL=RepeatingLastDayEditor.js.map